import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_3 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_5 = { class: "menu-item-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_8 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-copy" })
], -1)
const _hoisted_10 = {
  key: 2,
  class: "menu-item"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      filter: false,
      filterPlaceholder: 'message.SELECT',
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onSearch: _ctx.searchHandler,
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getShippingMethods(1, true))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      loading: _ctx.loader,
      columns: _ctx.columns,
      rows: _ctx.shippingMethods,
      pagination: _ctx.pagination,
      padding: 3,
      onHandleCurrentChange: _ctx.handleCurrentChange
    }, {
      "cell-name": _withCtx(({row:item}) => [
        _createTextVNode(_toDisplayString(JSON.parse(item?.name)[`${_ctx.systemLocale}`]?.name), 1)
      ]),
      "cell-status": _withCtx(({row:item}) => [
        (item?.status == 1)
          ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
          : (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
      ]),
      "cell-position": _withCtx(({row:item}) => [
        _createVNode("div", null, [
          _createVNode("input", {
            type: "number",
            class: "form-control position custom",
            min: 1,
            placeholder: _ctx.$t('message.SORT'),
            value: item?.position,
            onChange: ($event: any) => (
                            $event.target.value = parseInt($event.target.value) > 0 ? (parseInt($event.target.value), _ctx.updatePosition(item?.position, parseInt($event.target.value))) : item?.position
                        )
          }, null, 40, ["placeholder", "value", "onChange"])
        ])
      ]),
      "cell-actions": _withCtx(({row:item}) => [
        (item?.id != 9)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "action-btn",
              type: "button",
              onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
            }, [
              _hoisted_4,
              _createVNode("div", {
                class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
              }, [
                _createVNode("div", _hoisted_5, [
                  (_ctx.$can('edit_shipping_method'))
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("a", {
                          onClick: ($event: any) => (_ctx.handleEdit(item)),
                          class: "menu-link me-1"
                        }, [
                          _hoisted_7,
                          _createTextVNode(_toDisplayString(_ctx.$t('message.EDIT')), 1)
                        ], 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$can('copy_shipping_method'))
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _createVNode("a", {
                          onClick: ($event: any) => (_ctx.handleCopy(item?.uuid)),
                          class: "menu-link me-1"
                        }, [
                          _hoisted_9,
                          _createTextVNode(_toDisplayString(_ctx.$t('message.COPY')), 1)
                        ], 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$can('delete_shipping_method'))
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("a", {
                          onClick: ($event: any) => (_ctx.handleDelete(item?.id)),
                          class: "menu-link me-1"
                        }, [
                          _hoisted_11,
                          _createTextVNode(_toDisplayString(_ctx.$t('message.DELETE')), 1)
                        ], 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ], 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange"])
  ]))
}